/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  flex: props => ({
    display: 'flex',
    justifyContent: props.justify,
    alignItems: props.align,
    ...props
  })
});

const Flex = ({ id='flex', className, style, children, onClick, ...props }) => {
  const classes = useStyles(props);
  return (
    <div
      id ={id}
      className={`${classes.flex} ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Flex;
